import { Col, Row, Typography } from "antd";
import React from "react";
import BreadCrumbs from "../navigation/breadcrumb";

const Style = {
  marginRight: "1rem",
  marginBottom: "1rem",
  fontSize: "40px",
  backgroundColor: "#e9ecef",
  paddingLeft: "1rem",
  // paddingRight: '1rem',
  paddingTop: "0.25rem",
  paddingBottom: "0.25rem",
  borderRadius: "0.75rem"
};

const PageTitle = ({ ...props }) => {
  return (
    <Row justify="space-between" align="middle">
      <Col>
        <div className="erp-page-title" style={Style}>
          {props.icon}
        </div>
      </Col>
      <Col>
        <Row gutter={[0, 0]}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Typography.Title style={{ marginTop: "-16px" }} level={3}>
              {props.title}
            </Typography.Title>
          </Col>
          {!props.hideBreadcrumb && (
            <Col lg={24} md={24} sm={24} xs={24}>
              <BreadCrumbs />
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default PageTitle;
